import React, { useCallback, useState } from 'react';
import { Card, Tab } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { Role } from '../../../common/spdCore/authorization/roles';
import { Filter } from '../RegistersView/Filter';
import { TabsHistory } from '../../../app/components/TabsHistory';
import { ReportSynevoCompaniesSearch } from '../../components/Reports/ReportSynevoCompaniesSearch';

enum ReportCompaniesTabs {
  WITH_CODE_COMPANY = 'Wg firmy i badania pomocniczego',
}

export const ReportSynevoCompaniesView: React.FC = () => {
  const spd = useSpdCore();
  const [companyId, setCompanyId] = useState<string | undefined>();
  const [dateFrom, setDateFrom] = useState<Date | undefined>(
    new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0),
  );
  const [dateTo, setDateTo] = useState<Date | undefined>();

  const getData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) =>
      spd.reports.getSynevoCompaniesByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        dateFrom,
        dateTo,
        companyId,
      ),
    [spd.reports, dateFrom, dateTo, companyId],
  );

  const getCount = useCallback(
    (filterText?: string) =>
      spd.reports.getSynevoCompaniesCount(
        filterText,
        dateFrom,
        dateTo,
        companyId,
      ),
    [spd.reports, dateFrom, dateTo, companyId],
  );

  return (
    <>
      <Card>
        <Card.Header>{'Zestawienie SYNEVO'}</Card.Header>
        <Card.Body>
          <Filter
            headerName={
              'Zestawienie zrealizowanych badań w SYNEVO wg firm i badania pomocniczego'
            }
            roles={[
              Role.MedicalAssessor,
              Role.MedicalSpecialist,
              Role.PsychologistAssessor,
              Role.PsychologistSpecialist,
            ]}
            withUser={false}
            withDate={true}
            withEndStartDate={true}
            withHealthcareFacility={false}
            withCompany={true}
            onChangeCompanyId={setCompanyId}
            onChangeDateFrom={setDateFrom}
            onChangeDateTo={setDateTo}
            canClean={true}
            emptyOnStart={true}
          />
          <TabsHistory
            activeKey={ReportCompaniesTabs.WITH_CODE_COMPANY}
            id="product"
            className="mb-3"
            mountOnEnter
            unmountOnExit
          >
            <Tab
              eventKey={ReportCompaniesTabs.WITH_CODE_COMPANY}
              title={ReportCompaniesTabs.WITH_CODE_COMPANY}
              className="m-3"
            >
              <ReportSynevoCompaniesSearch
                getData={getData}
                getCount={getCount}
              />
            </Tab>
          </TabsHistory>
        </Card.Body>
      </Card>
    </>
  );
};
